import { ViewType } from "src/app/models/Enums";

import { ScheduleDueType } from "./Enums";

export class ToolFilter {
  booleanFilters: boolean[] = [];
  dateFilters: [] = [];
  numberFilters: [] = [];
  search: string = "";
  serviceDueFilters: ScheduleDueType[] = [];
  serviceDueMonths: number = 1;
  calibrationDueMonths: number = 1;
  statusFilters: unknown[] = [];
  stringFilters: [] = [];
  worktypeFilters: [] = [];
  skip?: number;
  take?: number;
  gridViewType: ViewType;
  columnFilters: ColumnFilter[];
  filterOnlyNoDepartment: boolean = false;

  constructor(
    public companyId?: string,
    public department?: string,
    public asc?: boolean,
    public sort?: string,
  ) {
    //* Reset Side Bar filters
    this.columnFilters = [];
    this.calibrationDueMonths = 1;
    this.serviceDueMonths = 1;
  }
}

export class ColumnFilter {
  values: string[];

  constructor(public property?: string) {
    this.values = [];
  }
}
